import type { TagSource, WorklogEvent } from './types';

export function eventTagPrefix(e: WorklogEvent): string | null {
  const candidates: string[] = [];
  if (e.note) candidates.push(e.note);
  if (e.task) candidates.push(e.task);
  if (e.active_task) candidates.push(e.active_task);
  for (const s of candidates) {
    const m = String(s).match(/\[([a-z]+-\d+)\]/i);
    if (m) return m[1].toLowerCase();
  }
  return null;
}

export function eventHash(e: WorklogEvent): string {
  const s = JSON.stringify({
    e: e.event || '',
    n: (e.ntp && e.ntp.epoch) || 0,
    t: e.task || '',
    note: e.note || '',
    cat: e.category || '',
    url: e.url || '',
    at: e.active_task || '',
    c: e.contract || '',
    d: e.duration_s || 0,
  });
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619) >>> 0;
  }
  return h.toString(36);
}

export function effectiveTag(e: WorklogEvent, overlayTags: Record<string, string>): string | null {
  return eventTagPrefix(e) || overlayTags[eventHash(e)] || null;
}

export function tagSource(e: WorklogEvent, overlayTags: Record<string, string>): TagSource {
  if (eventTagPrefix(e)) return 'prefix';
  if (overlayTags[eventHash(e)]) return 'overlay';
  return null;
}
